// A pattern's template (`Sale <uuid> moved to LIVE`) as parts to draw, and as a query that keeps or excludes it: its
// literal fragments as phrases, which the text index answers fast and anyone can read in the query bar.
const PLACEHOLDER = /<(uuid|email|ip|hex|code|n|str)>/g;

export const PLACEHOLDER_LABEL: Readonly<Record<string, string>> = {
    uuid: 'uuid',
    email: 'email',
    ip: 'ip',
    hex: 'hex',
    code: 'code',
    n: '#',
    str: 'text',
};

export type TemplatePart = { kind: 'text'; text: string } | { kind: 'slot'; name: string };

export function templateParts(template: string): TemplatePart[] {
    const parts: TemplatePart[] = [];
    let last = 0;
    for (const match of template.matchAll(PLACEHOLDER)) {
        if ((match.index ?? 0) > last) {
            parts.push({ kind: 'text', text: template.slice(last, match.index) });
        }
        parts.push({ kind: 'slot', name: match[1] as string });
        last = (match.index ?? 0) + match[0].length;
    }
    if (last < template.length) {
        parts.push({ kind: 'text', text: template.slice(last) });
    }

    return parts;
}

// The fragments worth matching: three letters or digits at least, so `] [` and `-` do not count.
export function patternPhrases(template: string): string[] {
    return template
        .split(PLACEHOLDER)
        .filter((_, index) => index % 2 === 0)
        .map((fragment) => fragment.trim())
        .filter((fragment) => fragment.replace(/[^\p{L}\p{N}]/gu, '').length >= 3);
}

const phrase = (text: string): string => `"${text.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;

export function keepPattern(q: string, template: string): string | null {
    const phrases = patternPhrases(template);

    return phrases.length === 0 ? null : [q.trim(), ...phrases.map(phrase)].filter(Boolean).join(' ');
}

export function excludePattern(q: string, template: string): string | null {
    const phrases = patternPhrases(template);

    return phrases.length === 0 ? null : [q.trim(), `-(${phrases.map(phrase).join(' ')})`].filter(Boolean).join(' ');
}
